import React, { useState, useContext, useEffect } from 'react'
import {
    handleRedirectInternal,
    mapData,
    jsonToFormData,
    currencyFormat,
} from '../../Product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../Product/context/auth/authContext'
import AlertContext from '../../Product/context/alert/alertContext'
import ProductContext from '../../Product/context/product/productContext'
import NoRecordsFound from '../../Product/components/atoms/NoRecordsFound'
import Loader from '../../assets/loader'
import moment from 'moment'
import { Pagination } from '@material-ui/lab'

const Rewards = () => {
    const authContext = useContext(AuthContext)
    const productContext = useContext(ProductContext)
    const validationArray = Yup.object({})
    const [regBtnLoading, setRegBtnLoading] = useState(false)
    const [listLoading, setListLoading] = useState(false)
    const [redeemsList, setRedeemList] = useState([])
    const [redeemsCount, setRedeemCount] = useState(0)
    const { user, loadUser, isAuthenticated } = authContext
    const { rewardsList, rewardsEnablelist, responseStatus, redeemEnablelist } = productContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [revardPoint, setRevardPoint] = useState(0)
    const [page, setPage] = useState(0)

    useEffect(() => {
        console.log('rewardsList list -', rewardsList)
        if (rewardsList?.results?.length > 0) {
            setRedeemList(rewardsList.results)
            setRedeemCount(rewardsList?.totalresults)
            setListLoading(false)
        } else {
            setListLoading(false)
        }
        setListLoading(false)
    }, [rewardsList])
    useEffect(() => {
        if (user) {
            setListLoading(true)
            rewardsEnablelist({
                site_id: global?.storeDetails?.site_id,
                user_id: user.id,
                page: page,
                perlimit: 10,
            })
            const fetchRedeemList = async () => {
                if (user) {
                    const res = await redeemEnablelist({
                        site_id: global?.storeDetails?.site_id,
                        user_id: user.id,
                    })
                    setRevardPoint(res.data.rewardpoint[0].reward_point)
                    setListLoading(false)
                }
            }
            fetchRedeemList()
        }
    }, [user, page])

    return (
        <div>
            {global.pluginConfiguration?.reward_points?.enable ? (
                listLoading ? (
                    ''
                ) : (
                    <div className="accChild">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="mp-head">
                                You currently have {revardPoint}{' '}
                                <i style={{ color: '#fcb444' }}>reward points!</i>
                            </h4>
                        </div>
                    </div>
                )
            ) : (
                ''
            )}
            {listLoading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : redeemsList.length > 0 ? (
                <>
                    <div className="table-responsive">
                        {
                            <table className="table table-hover mobile-table responisveTable">
                                <thead className="hidden-mobile">
                                    <tr>
                                        {/* <th></th> */}
                                        <th className="numCell" role="id">
                                            Points
                                        </th>
                                        {/* <th role="Plan">Added by</th> */}
                                        <th role="Amount">Added Date</th>
                                        <th role="Notes">Notes</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {redeemsList.length !== 0 &&
                                        redeemsList.map((item, index) => {
                                            return (
                                                <>
                                                    {item ? (
                                                        <tr key={index}>
                                                            <td data-label="Points">
                                                                {item.amount}
                                                            </td>

                                                            {/* <td data-label="amount">
                                                            {item?.employee_name}
                                                        </td> */}

                                                            <td data-label="Added Date">
                                                                {moment
                                                                    .utc(
                                                                        item?.new_date.replace(
                                                                            ' PM',
                                                                            '',
                                                                        ),
                                                                    )
                                                                    .local()
                                                                    .format('dddd, MMMM DD, YYYY')}
                                                            </td>
                                                            <td
                                                                className="tableLastColumnsAlign"
                                                                data-label="Notes"
                                                            >
                                                                Received on{' '}
                                                                {item?.processing_option ===
                                                                'Admin Reward Points'
                                                                    ? item?.credit_notes === 'add'
                                                                        ? 'added reward points'
                                                                        : item?.credit_notes ===
                                                                          'remove'
                                                                        ? 'removed reward points'
                                                                        : null
                                                                    : item?.processing_option ===
                                                                      'subscribe_emails'
                                                                    ? 'email sign up'
                                                                    : item?.processing_option ===
                                                                      'signup_bonus'
                                                                    ? 'registration'
                                                                    : item?.processing_option ===
                                                                      'win_auctions'
                                                                    ? 'won auction'
                                                                    : item?.processing_option ===
                                                                      'free_item_bin_store'
                                                                    ? 'bin store visit'
                                                                    : item?.processing_option ===
                                                                      'bin_store'
                                                                    ? 'bin store purchase'
                                                                    : item?.processing_option
                                                                    ? item.processing_option.toLowerCase()
                                                                    : item?.processing_option}
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </>
                                            )
                                        })}
                                </tbody>
                            </table>
                        }
                    </div>
                    <Pagination
                        count={Math.ceil(redeemsCount / 10)}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                    />
                </>
            ) : (
                <NoRecordsFound />
            )}
        </div>
    )
}

export default Rewards
